import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import calendar from '@/components/env-bigData/calendarYear';
import yearSelect from '@/components/date/yearSelect';
import { queryYearWasteStand } from '@/api/api';
import { getAction } from '@/api/manage';
export default {
  mixins: [GetSiteIdMixin],
  data: function data() {
    return {
      st: 0,
      quantum: '2020-11',
      showToast: false,
      toastText: '',
      year: new Date().getFullYear(),
      showCalendar: true,
      siteId: 0,
      url: '',
      toast: 0
    };
  },
  created: function created() {
    var _this = this;

    this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/responseYear';
    window.addEventListener('setItem', function (e) {
      if (e.key == 'siteType') {
        _this.url = '/online/st' + window.sessionStorage.getItem('siteType') + '/responseYear';
      }
    });
  },
  components: {
    calendar: calendar,
    yearSelect: yearSelect
  },
  mounted: function mounted() {// window.addEventListener('setItem', (e) => {
    // 	if (e.key == 'siteType') {
    // 		// that.showCalendar = false
    // 		// that.$nextTick(()=>{
    // 		// 	that.showCalendar = true
    // 			// that.$nextTick(()=>{
    // 			// 	that.getCalendar()
    // 			// })
    // 		// })
    // 		window.sessionStorage.getItem('siteType')
    // 		// this.getCalendar()
    // 	}
    // })
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.siteId = ids[1];
      this.getCalendar(ids[1]);
    },
    st: function st(value) {},
    '$store.state.bgLight': function $storeStateBgLight() {
      this.getCalendar(this.siteId);
    }
  },
  methods: {
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    onYearRangeChange: function onYearRangeChange(e) {
      this.year = e;

      if (this.toast) {
        this.getCalendar(this.siteId);
      }

      this.toast = 1;
    },
    ontoGet: function ontoGet(value, year) {
      this.$router.push({
        path: '/online/cn2061',
        query: {
          year: year,
          path: '/online/calendar'
        }
      }); // let tostValue 
      // if (value) this.toastText = year+':'+value
      // else this.toastText =  year+':暂无数据'
      // this.showToast = true
      // setTimeout(() => {
      // 	this.showToast = false
      // }, 2000)
    },
    getCalendar: function getCalendar(scopeId) {
      var _this2 = this;

      getAction(this.url, {
        scopeId: scopeId,
        quantum: this.year
      }).then(function (res) {
        if (parseInt((window.sessionStorage.getItem('siteType') - 0) / 10) == 3 || window.sessionStorage.getItem('siteType') == '52') {
          if (res.success && res.result.length > 0) {
            res.result.forEach(function (item1, index1) {
              var a = [];
              item1.records.forEach(function (item, index) {
                // if (index < (item1.records.length - 3)) {
                if (item.attrs.targetStandard && item.attrs.upStandard !== null) {
                  if (item.attrs.upStandard) a.push(1);else a.push(2);
                } else {
                  a.push(0);
                } // }

              });
              var refs = _this2.$refs['calendar' + index1][0];
              refs.initBarChart(_this2.year, index1 + 1, a, ['#ccc', 'green', 'red'], ['', '达标', '不达标']);
            });
          }
        } else {
          if (res.success && res.result.length > 0) {
            res.result.forEach(function (item1, index1) {
              var a = [];
              var color = [];
              var title = [];
              item1.records.forEach(function (item, index) {
                // if (index < (item1.records.length - 3)) {
                a.push(index);

                if (item.attrs.currentStandard) {
                  color.push(item.attrs.currentStandard.color);
                  title.push(item.attrs.currentStandard.title);
                } else {
                  color.push('#ccc');
                  title.push('');
                } // }

              });
              var refs = _this2.$refs['calendar' + index1][0];
              refs.initBarChart(_this2.year, index1 + 1, a, color, title);
            });
          }
        }
      }); //  getAction(this.url, {
      // 	scopeId,
      // 	quantum: this.year
      // }).then(res=>{
      // })
      // queryYearWasteStand({
      // 	scopeId,
      // 	quantum: this.year
      // }).then(res => {
      // 	if (res.success && res.result.length > 0) {
      // 		res.result.forEach((item1,index1)=>{
      // 			let a = []
      // 			item1.records.forEach((item, index) => {
      // 				if (index < (item1.records.length - 3)) {
      // 					if (item.attrs.targetStandard) {
      // 						if (item.attrs.upStandard) a.push(1)
      // 						else a.push(2)
      // 					} else {
      // 						a.push(0)
      // 					}
      // 				}
      // 			})
      // 			let refs = this.$refs['calendar' + index1][0]
      // 			refs.initBarChart(
      // 				this.year,
      // 				index1 + 1,
      // 				a,
      // 				['#ccc', 'green', 'red'],
      // 				['', '合格', '不合格']
      // 			)
      // 		})
      // 	}else{
      // 		for(let i=0;i<12;i++){
      // 			let a = []
      // 			for(let j=0;j<this.getDaysInOneMonth(this.year,i+1);j++){
      // 				a.push(0)
      // 				let refs = this.$refs['calendar' + i][0]
      // 				refs.initBarChart(
      // 					this.year,
      // 					i + 1,
      // 					a,
      // 					['#ccc', 'green', 'red'],
      // 					['', '合格', '不合格']
      // 				)
      // 			}
      // 		}
      // 	}
      // })
      // let that = this
      // let a = []
      // for (let i = 0; i < 31; i++) {
      // 	a.push(1)
      // }
      // for(let j=0;j<12;j++){
      // 	let refs = that.$refs
      // 	refs['calendar'+j][0].initBarChart(
      // 		that.quantum.split('-')[0],
      // 		that.quantum.split('-')[1],
      // 		a,
      // 		['#ccc', 'green', 'red'],
      // 		['', '合格', '不合格']
      // 	)
      // }
    }
  }
};